{
    "form_error_required": "Erforderlich",
    "sales_draft__header__sub_title__order": "Neuer Auftrag",
    "sales_draft__header__sub_title__quote": "Neues Angebot",
    "sales_draft__item_form__quantity": "Menge",
    "sales_draft__item_form__price": "Preis",
    "sales_draft__item_form__rebate": "Rabatt",
    "sales_draft__item_form__gross_margin_percent": "DB %",
    "sales_draft__item_form__gross_margin": "DB",
    "sales_draft__item_form__total": "Summe",
    "sales_draft__item_form__storage": "Lager",
    "sales_draft__item_form__storage_from_header": "Aus Kopfdaten ({{id}}: {{name}})",
    "sales_draft__item_form__shipping_type_id": "Versandart",
    "sales_draft__item_form__note": "Zeilennotiz",
    "sales_draft__item_form__encoded_price": "Warenschlüssel",
    "sales_draft__edit__line_item": "Mehr bearbeiten",
    "sales_draft__delete__line_item": "Löschen",
    "sales_draft__line_items__table_header__article": "Artikel",
    "sales_draft__line_items__table_header__quantity": "Menge",
    "sales_draft__line_items__table_header__price": "Preis",
    "sales_draft__line_items__table_header__rebate": "Rabatt",
    "sales_draft__line_items__table_header__gross_margin_percent": "DB %",
    "sales_draft__summary__overview": "Übersicht",
    "sales_draft__summary__number_of_positions": "Anzahl Positionen",
    "sales_draft__summary__contribution_margin_percent": "Deckungsbeitrag %",
    "sales_draft__summary__contribution_margin": "Deckungsbeitrag",
    "sales_draft__summary__total_position": "Summe Positionen",
    "sales_draft__button_group__search_catalog": "Katalog",
    "sales_draft__button_group__continue": "Weiter zu den Kopfdaten",
    "sales_draft__button_group__cancel": "Abbrechen",
    "sales_draft__stepper__line_items": "Einzelpositionen",
    "sales_draft__stepper__header": "Kopfzeile",
    "sales_draft__header__billing_address": "Rechnungsadresse",
    "sales_draft__header__contact_person": "Kontaktperson",
    "sales_draft__header__due_date": "Gültig bis",
    "sales_draft__header__order_type": "Auftragsart",
    "sales_draft__header__order_type__select": "Auftragsart auswählen",
    "sales_draft__header__quote_type": "Angebotsart",
    "sales_draft__header__quote_type__select": "Angebotsart auswählen",
    "sales_draft__header__shipping_type": "Standard Versandart",
    "sales_draft__header__shipping_type__select": "Versandart auswählen",
    "sales_draft__header__notes": "Kopftext",
    "sales_draft__header__notes_placeholder": "Füge eine Notiz für den Kunden hinzu, die auf PDF Dokumenten angezeigt wird",
    "sales_draft__header__commission": "Kommission",
    "sales_draft__header__shipping_address": "Lieferadresse auswählen",
    "sales_draft__header__delivery_date": "Gewünschtes Datum",
    "sales_draft__header__contact_person__select": "Kontaktperson auswählen",
    "sales_draft__header__submit_error": "Fehler beim Speichern in der Warenwirtschaft",
    "sales_draft__button_group__submit": "In der Warenwirtschaft speichern",
    "sales_draft__button_group__back_to_line_items": "Zurück",
    "sales_draft__QUOTE__submit_confirmation_dialog__title": "Angebot in der Warenwirtschaft speichern?",
    "sales_draft__QUOTE__submit_confirmation_dialog__description": "Das Angebot wird in der Warenwirtschaft gespeichert und kann nicht mehr in Plato bearbeitet werden.",
    "sales_draft__ORDER__submit_confirmation_dialog__title": "Auftrag in der Warenwirtschaft speichern?",
    "sales_draft__ORDER__submit_confirmation_dialog__description": "Der Auftrag wird in der Warenwirtschaft gespeichert und kann nicht mehr in Plato bearbeitet werden.",
    "sales_draft__ORDER__submit_success_toast__title": "Auftrag erfolgreich in der Warenwirtschaft gespeichert",
    "sales_draft__ORDER__submit_success_toast__description": "Er wird in Kürze für alle in der Warenwirtschaft zu sehen sein",
    "sales_draft__QUOTE__submit_success_toast__title": "Angebot erfolgreich in der Warenwirtschaft gespeichert",
    "sales_draft__QUOTE__submit_success_toast__description": "Es wird in Kürze für alle in der Warenwirtschaft zu sehen sein",
    "sales_draft__submit_confirmation_dialog__accept": "Bestätigen",
    "sales_draft__submit_confirmation_dialog__reject": "Weiter bearbeiten",
    "sales_draft__cancel_confirmation_dialog__title": "Vorgang abbrechen und löschen?",
    "sales_draft__cancel_confirmation_dialog__description": "Der Vorgang wird nicht gespeichert. Diese Aktion kann nicht rückgängig gemacht werden.",
    "sales_draft__cancel_confirmation_dialog__reject": "Weiter bearbeiten",
    "sales_draft__cancel_confirmation_dialog__accept": "Vorgang löschen",
    "sales_draft__incremental_quantity_dialog__title": "Anbruch Verpackungseinheit nicht möglich",
    "sales_draft__incremental_quantity_dialog__description": "Wähle vielfaches von Verpackungseinheit",
    "sales_draft__incremental_quantity_dialog__confirm": "Hinzufügen",
    "sales_draft__list_view__header__customer": "Kunde",
    "sales_draft__list_view__header__creation_date": "Erstellt",
    "sales_draft__list_view__header__total": "Summe",
    "sales_draft__list_view__header__positions": "Positionen",
    "sales_draft__list_view__header__created_by": "Erstellt von",
    "sales_draft__list_view__action__edit": "Bearbeiten",
    "sales_draft__list_view__action__delete": "Löschen",
    "sales_draft__list_view__filter_customers": "Kunden",
    "sales_draft__list_view__filter_users": "Erstellt von",
    "sales_draft__list_view__filter_states": "Status",
    "sales_draft__list_view__search_placeholder": "Suche nach Kunde",
    "sales_draft__delete_success_toast__title": "Entwurf erfolgreich gelöscht",
    "sales_draft__delete_success_toast__description": "Hier kannst du einen <linkTag>neuen Vorgang erstellen</linkTag>",
    "sales_draft__delete_confirmation_dialog__title": "Entwurf löschen?",
    "sales_draft__delete_confirmation_dialog__description": "Der Entwurf wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    "sales_draft__submit_error_toast__title": "Fehler beim Speichern in der Warenwirtschaft",
    "sales_draft__submit_error_toast__description": "Der Entwurf konnte nicht gespeichert werden. Bitte versuche es erneut.",
    "sales_draft__update_error_toast__title": "Fehler beim Speichern",
    "sales_draft__update_error_toast__description": "Der Entwurf konnte nicht gespeichert werden. Bitte versuche es erneut.",
    "sales_draft__quick_filters__by_me": "Meine Entwürfe",
    "sales_draft__quick_filters__submitted": "Vor kurzem an die Warenwirtschaft übermittelt",
    "sales_draft__list_view__action__view": "Vorgang ansehen",
    "sales_draft__status__NEW": "Entwurf",
    "sales_draft__status__SUBMITTED": "Übermittelt",
    "sales_draft__recommended_header": "Empfohlene Produkte",
    "sales_draft__recommended_header__customer": "Top-Produkte dieses Kunden",
    "sales_draft__recommended_header__tenant": "Meistverkaufte Produkte",
    "sales_draft__recommended_loading": "Lädt",
    "sales_draft__recommended_none": "Keine weiteren empfohlenen Produkte",
    "sales_draft__related_items_header": "Ähnliche Artikel",
    "sales_draft__error_no_unit": "Keine Verkaufseinheit gefunden",
    "sales_draft__error_stock": "Fehler beim Abrufen des Lagerbestands"
}
